import { UseMutateFunction } from "@tanstack/react-query";
import { AxiosError } from "axios";
import * as yup from "yup";

export type Personel = {
  id: string;
  email: string;
  password?: string;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
  can_follow: boolean;
};

export interface StaffListResponse extends Array<Personel> {}

export interface StaffModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  userData?: Personel;
  mutate?: UseMutateFunction<StaffListResponse, AxiosError<any>, any, unknown>;
}

export interface StaffDetailModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  userData?: Personel;
}

export interface StaffAddRequest {
  email: string;
  password?: yup.Maybe<string | undefined>;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
}

export interface StaffAddResponse {
  email: string;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
  status: number;
}

export interface StaffUpdateRequest {
  id: string;
  email: string;
  password?: yup.Maybe<string | undefined>;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
}

export interface StaffUpdateResponse {
  email: string;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
  status: number;
}

export interface StaffDeleteRequest {
  id: string;
}

export interface StaffDeleteResponse {
  email: string;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
  status: number;
}

export const staffAddSchema = yup.object().shape({
  email: yup
    .string()
    .email("Geçerli bir email adresi giriniz")
    .required("Email boş bırakılamaz"),
  password: yup.string().required("Şifre boş bırakılamaz"),
  fullname: yup.string().required("Tam ad boş bırakılamaz"),
  username: yup.string().required("Kullanıcı adı boş bırakılamaz"),
  date_of_start: yup.date().required("Başlangıç tarihi boş bırakılamaz"),
  phone_number: yup
    .string()
    .required("Telefon numarası boş bırakılamaz")
    .matches(/^0[0-9]{10}$/, "Geçerli bir telefon numarası girin"),
  salary_net: yup
    .number()
    .min(0, "Net maaş en az 0 olmalıdır")
    .required("Net Maaş bırakılamaz"),
  salary_gross: yup
    .number()
    .min(0, "Brüt maaş en az 0 olmalıdır")
    .required("Brüt maaş bırakılamaz"),
});

export const staffUpdateSchema = yup.object().shape({
  email: yup.string().required("Email boş bırakılamaz"),
  password: yup.string().notRequired(),
  fullname: yup.string().required("Tam ad boş bırakılamaz"),
  username: yup.string().required("Kullanıcı adı boş bırakılamaz"),
  date_of_start: yup.date().required("Başlangıç tarihi boş bırakılamaz"),
  phone_number: yup
    .string()
    .required("Telefon numarası boş bırakılamaz")
    .matches(/^0[0-9]{10}$/, "Geçerli bir telefon numarası girin"),
  salary_net: yup
    .number()
    .min(0, "Net maaş en az 0 olmalıdır")
    .required("Net Maaş bırakılamaz"),
  salary_gross: yup
    .number()
    .min(0, "Brüt maaş en az 0 olmalıdır")
    .required("Brüt maaş bırakılamaz"),
});
